export enum EMPRESA_ID {
    SUPERDEPORTE = 1,
    ADIDAS = 2,
    REEBOK = 3,
    EQUINOX = 4,
}
